import React, { useState } from "react";

const F = ({ label, value, onChange, type = "text" }) => (
  <div style={{ marginBottom: 10 }}>
    <label style={{ display: "block", fontSize: 11, fontWeight: 600,
      color: "#5a6070", textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 4 }}>
      {label}
    </label>
    {type === "textarea" ? (
      <textarea value={value} onChange={e => onChange(e.target.value)}
        style={{ width: "100%", padding: "6px 8px", border: "0.5px solid #e2e4e8",
          borderRadius: 6, fontSize: 12, color: "#1a1e2e", background: "#fff",
          resize: "vertical", minHeight: 60, outline: "none",
          fontFamily: "inherit", lineHeight: 1.5, boxSizing: "border-box" }} />
    ) : type === "select" ? null : (
      <input type={type} value={value} onChange={e => onChange(e.target.value)}
        style={{ width: "100%", height: 32, padding: "0 8px",
          border: "0.5px solid #e2e4e8", borderRadius: 6,
          fontSize: 12, color: "#1a1e2e", background: "#fff",
          outline: "none", boxSizing: "border-box" }} />
    )}
  </div>
);

const Select = ({ label, value, onChange, options }) => (
  <div style={{ marginBottom: 10 }}>
    <label style={{ display: "block", fontSize: 11, fontWeight: 600,
      color: "#5a6070", textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 4 }}>
      {label}
    </label>
    <div style={{ position: "relative" }}>
      <select value={value} onChange={e => onChange(e.target.value)}
        style={{ width: "100%", height: 32, padding: "0 28px 0 8px",
          border: "0.5px solid #e2e4e8", borderRadius: 6,
          fontSize: 12, color: "#1a1e2e", background: "#fff",
          appearance: "none", outline: "none", cursor: "pointer", boxSizing: "border-box" }}>
        {options.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#8a909e" strokeWidth="2"
        style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
        <polyline points="6 9 12 15 18 9"/>
      </svg>
    </div>
  </div>
);

const Divider = ({ label }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "12px 0 10px" }}>
    <div style={{ flex: 1, height: "0.5px", background: "#e2e4e8" }} />
    <span style={{ fontSize: 10, color: "#aab0be", fontWeight: 600, letterSpacing: 0.5 }}>{label}</span>
    <div style={{ flex: 1, height: "0.5px", background: "#e2e4e8" }} />
  </div>
);

// ── Fleet Overview Editor ─────────────────────────────────────────
export const FleetOverviewEditor = ({ data, onChange }) => (
  <div>
    <F label="Fleet Risk Score (0-100)" type="number"
      value={data.fleetRisk} onChange={v => onChange({ ...data, fleetRisk: Number(v) })} />
    <F label="Risk Badge Text"
      value={data.badge} onChange={v => onChange({ ...data, badge: v })} />
    <F label="Description" type="textarea"
      value={data.description} onChange={v => onChange({ ...data, description: v })} />
    <Divider label="STATS" />
    <F label="High Risk Vessels"
      value={data.highRisk} onChange={v => onChange({ ...data, highRisk: v })} />
    <F label="High Risk Note"
      value={data.highRiskNote} onChange={v => onChange({ ...data, highRiskNote: v })} />
    <F label="Open Risk Items"
      value={data.openItems} onChange={v => onChange({ ...data, openItems: v })} />
    <F label="Open Items Note"
      value={data.openItemsNote} onChange={v => onChange({ ...data, openItemsNote: v })} />
    <F label="Repair Exposure"
      value={data.repairExposure} onChange={v => onChange({ ...data, repairExposure: v })} />
    <F label="Exposure Note"
      value={data.exposureNote} onChange={v => onChange({ ...data, exposureNote: v })} />
  </div>
);

// ── Vessel Rank Editor ────────────────────────────────────────────
export const VesselRankEditor = ({ data, onChange }) => (
  <div>
    {data.vessels.map((v, i) => (
      <div key={i}>
        <Divider label={`VESSEL ${i + 1}`} />
        <F label="Name"     value={v.name}     onChange={val => { const a=[...data.vessels]; a[i]={...a[i],name:val};     onChange({...data,vessels:a}); }} />
        <F label="Location" value={v.location} onChange={val => { const a=[...data.vessels]; a[i]={...a[i],location:val}; onChange({...data,vessels:a}); }} />
        <F label="Date"     value={v.date}     onChange={val => { const a=[...data.vessels]; a[i]={...a[i],date:val};     onChange({...data,vessels:a}); }} />
        <F label="Cost"     value={v.cost}     onChange={val => { const a=[...data.vessels]; a[i]={...a[i],cost:val};     onChange({...data,vessels:a}); }} />
        <F label="Description" type="textarea" value={v.desc} onChange={val => { const a=[...data.vessels]; a[i]={...a[i],desc:val}; onChange({...data,vessels:a}); }} />
      </div>
    ))}
    <button
      onClick={() => onChange({ ...data, vessels: [...data.vessels,
        { rank: data.vessels.length + 1, name: "NEW VESSEL", location: "PORT", date: new Date().toLocaleDateString(), cost: "$0K", desc: "Description here" }
      ]})}
      style={{ width: "100%", marginTop: 8, padding: "7px", border: "0.5px dashed #1a9e78",
        borderRadius: 6, background: "none", color: "#1a9e78", fontSize: 12, cursor: "pointer" }}>
      + Add Vessel
    </button>
  </div>
);

// ── Vessel Score Cards Editor ─────────────────────────────────────
export const VesselScoreEditor = ({ data, onChange }) => (
  <div>
    {data.vessels.map((v, i) => (
      <div key={i}>
        <Divider label={`${v.name}`} />
        <F label="Name"       value={v.name}      onChange={val => { const a=[...data.vessels]; a[i]={...a[i],name:val};      onChange({...data,vessels:a}); }} />
        <Select label="Risk Level" value={v.risk} options={["HIGH","MEDIUM","LOW"]}
          onChange={val => { const a=[...data.vessels]; a[i]={...a[i],risk:val}; onChange({...data,vessels:a}); }} />
        <F label="Risk Score (0-100)" type="number" value={v.score}
          onChange={val => { const a=[...data.vessels]; a[i]={...a[i],score:Number(val)}; onChange({...data,vessels:a}); }} />
        <F label="Description" type="textarea" value={v.desc}
          onChange={val => { const a=[...data.vessels]; a[i]={...a[i],desc:val}; onChange({...data,vessels:a}); }} />
        <F label="Open Items"  value={v.openItems} onChange={val => { const a=[...data.vessels]; a[i]={...a[i],openItems:val}; onChange({...data,vessels:a}); }} />
        <F label="Exposure"    value={v.exposure}  onChange={val => { const a=[...data.vessels]; a[i]={...a[i],exposure:val};  onChange({...data,vessels:a}); }} />
        <F label="Savings/mo"  value={v.savings}   onChange={val => { const a=[...data.vessels]; a[i]={...a[i],savings:val};   onChange({...data,vessels:a}); }} />
      </div>
    ))}
  </div>
);

// ── Risk Overview Editor ──────────────────────────────────────────
export const RiskOverviewEditor = ({ data, onChange }) => (
  <div>
    {data.vessels.map((v, i) => (
      <div key={i}>
        <Divider label={`${v.name}`} />
        <F label="Vessel Name" value={v.name}
          onChange={val => { const a=[...data.vessels]; a[i]={...a[i],name:val}; onChange({...data,vessels:a}); }} />
        <Select label="Trend" value={v.trend} options={["Worsening","Watch","Improving"]}
          onChange={val => { const a=[...data.vessels]; a[i]={...a[i],trend:val}; onChange({...data,vessels:a}); }} />
        <F label="Current Score" type="number" value={v.current}
          onChange={val => { const a=[...data.vessels]; a[i]={...a[i],current:Number(val)}; onChange({...data,vessels:a}); }} />
        <div style={{ marginBottom: 10 }}>
          <label style={{ display: "block", fontSize: 11, fontWeight: 600,
            color: "#5a6070", textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 6 }}>
            Week Values (W1–W4)
          </label>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 6 }}>
            {v.weeks.map((w, wi) => (
              <div key={wi}>
                <div style={{ fontSize: 10, color: "#aab0be", marginBottom: 2, textAlign: "center" }}>W{wi+1}</div>
                <input type="number" value={w}
                  onChange={e => {
                    const a=[...data.vessels]; const wks=[...a[i].weeks];
                    wks[wi]=Number(e.target.value); a[i]={...a[i],weeks:wks};
                    onChange({...data,vessels:a});
                  }}
                  style={{ width:"100%", height:32, textAlign:"center", border:"0.5px solid #e2e4e8",
                    borderRadius:6, fontSize:13, fontWeight:500, outline:"none", boxSizing:"border-box" }} />
              </div>
            ))}
          </div>
        </div>
      </div>
    ))}
  </div>
);

// ── Fleet Risk By Equipment Editor ────────────────────────────────
export const EquipmentEditor = ({ data, onChange }) => (
  <div>
    {data.equipment.map((eq, i) => (
      <div key={i}>
        <Divider label={`EQUIPMENT ${i + 1}`} />
        <F label="Name" value={eq.name}
          onChange={val => { const a=[...data.equipment]; a[i]={...a[i],name:val}; onChange({...data,equipment:a}); }} />
        <Select label="Risk Level" value={eq.risk} options={["HIGH","MEDIUM","LOW"]}
          onChange={val => { const a=[...data.equipment]; a[i]={...a[i],risk:val}; onChange({...data,equipment:a}); }} />
        <F label="Description" type="textarea" value={eq.desc}
          onChange={val => { const a=[...data.equipment]; a[i]={...a[i],desc:val}; onChange({...data,equipment:a}); }} />
      </div>
    ))}
    <button
      onClick={() => onChange({ ...data, equipment: [...data.equipment,
        { name: "New Equipment", risk: "LOW", desc: "Description here" }
      ]})}
      style={{ width: "100%", marginTop: 8, padding: "7px", border: "0.5px dashed #1a9e78",
        borderRadius: 6, background: "none", color: "#1a9e78", fontSize: 12, cursor: "pointer" }}>
      + Add Equipment
    </button>
  </div>
);